import { autorun } from "mobx";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { UiConstants } from "../../data/UiConstants";
import { LoadingSpinner } from "../shared/LoadingSpinner";
import { observer } from "mobx-react-lite";
import { Slider, SliderThumb, SliderTrack } from "../editor/Slider";
import { useTranslation } from "react-i18next";
import { sharedStore } from "../../stores/SharedStore";
import { AnimationPreviewCanvas, getAnimationPreviewCanvas } from "../../canvas/animationEditor/AnimationPreviewCanvas";
import { AnimationPreviewCanvasContainer } from "./AnimationPreviewCanvasContainer";
const PreviewContainer = styled.div.withConfig({
  displayName: "AnimationPreviewComponent__PreviewContainer",
  componentId: "sc-dw49t-0"
})(["position:relative;background-color:#000000;width:", "px;height:", "px;border-radius:", ";margin-left:auto;margin-right:auto;"], props => props.width + 4, props => props.height + 4, UiConstants.BORDER_RADIUS); // ${props => props.color ? props.color : "#FFFFFF"};

const SpinnerContainer = styled.div.withConfig({
  displayName: "AnimationPreviewComponent__SpinnerContainer",
  componentId: "sc-dw49t-1"
})(["position:absolute;width:20px;height:20px;top:", "px;left:", "px;"], props => props.height / 2 - 20, props => props.width / 2 - 20);
const SliderContainer = styled.div.withConfig({
  displayName: "AnimationPreviewComponent__SliderContainer",
  componentId: "sc-dw49t-2"
})(["display:flex;flex-direction:row;margin:8px;align-items:center;justify-content:center;flex-grow:1;"]);
const SliderLabel = styled.div.withConfig({
  displayName: "AnimationPreviewComponent__SliderLabel",
  componentId: "sc-dw49t-3"
})(["margin:4px;width:230px;"]);
export const AnimationPreviewComponent = observer(props => {
  const {
    t
  } = useTranslation();
  const [previewZoom, setPreviewZoom] = useState(1);
  const previewWidth = 500;
  const previewHeight = 750; // Create/dispose on mount/dismount, and when AnimationPreviewCanvas changes on hot reload

  useEffect(() => {
    const disposer = autorun(handleAnimationSelectionChange);
    return disposer;
  }, [AnimationPreviewCanvas]);
  useEffect(() => {
    const animationPreviewCanvas = getAnimationPreviewCanvas();

    if (animationPreviewCanvas) {
      animationPreviewCanvas.editMode = props.editMode;
    }
  }, [props.editMode, getAnimationPreviewCanvas()]);
  useEffect(() => {
    handleAnimationSelectionChange();
  }, [sharedStore.animationAssets]);

  function onSliderChange(value) {
    if (!props.store.hasAnimationSelected) return;
    setPreviewZoom(value);
    const animationPreviewCanvas = getAnimationPreviewCanvas();
    animationPreviewCanvas === null || animationPreviewCanvas === void 0 ? void 0 : animationPreviewCanvas.updateZoom(value);
  }

  function handleAnimationSelectionChange() {
    const animationPreviewCanvas = getAnimationPreviewCanvas();

    if (props.store.hasAnimationSelected) {
      var _props$store$selected, _props$store$selected2;

      animationPreviewCanvas === null || animationPreviewCanvas === void 0 ? void 0 : animationPreviewCanvas.updateAnimation((_props$store$selected = props.store.selectedAnimation) === null || _props$store$selected === void 0 ? void 0 : _props$store$selected.spine, (_props$store$selected2 = props.store.selectedAnimation) === null || _props$store$selected2 === void 0 ? void 0 : _props$store$selected2.animation);
    } else {
      animationPreviewCanvas === null || animationPreviewCanvas === void 0 ? void 0 : animationPreviewCanvas.updateAnimation(null, null);
    }
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PreviewContainer, {
    width: previewWidth,
    height: previewHeight
  }, /*#__PURE__*/React.createElement(AnimationPreviewCanvasContainer, {
    width: previewWidth,
    height: previewHeight
  }), props.store.currentlyLoadingAnimation && /*#__PURE__*/React.createElement(SpinnerContainer, {
    width: previewWidth,
    height: previewHeight
  }, /*#__PURE__*/React.createElement(LoadingSpinner, null))), props.showZoomSlider && /*#__PURE__*/React.createElement(SliderContainer, null, /*#__PURE__*/React.createElement(SliderLabel, null, t("editor.animation_preview_zoom") + ": " + Math.floor(previewZoom * 100) + "%"), /*#__PURE__*/React.createElement(Slider, {
    value: previewZoom,
    min: 0.05,
    max: 2,
    step: 0.01,
    renderTrack: SliderTrack,
    renderThumb: SliderThumb,
    onChange: onSliderChange
  })));
});